// Shared UI helpers
export const OTHER_RATE = 0.063845; // 6.3845% (Taxes & Others)
export const currencyFmt = (amt, ccy = 'CAD') => {
  const n = Number(amt ?? 0);
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: ccy }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
};

export const initials = (first, last) => {
  const f = (first || '').trim();
  const l = (last || '').trim();
  const i1 = f ? f[0].toUpperCase() : '';
  const i2 = l ? l[0].toUpperCase() : '';
  return (i1 + i2) || '👤';
};

export const placeholderImg =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="100%" height="100%" fill="#f1f5f9"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#94a3b8" font-family="sans-serif" font-size="20">No image</text></svg>`
  );
